var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdminUserCheck = function SvgAdminUserCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.6154H14V20L18.5 15.6154H21.5C22.3284 15.6154 23 14.961 23 14.1538V2.46154C23 1.65435 22.3284 1 21.5 1H10C9.17157 1 8.5 1.69281 8.5 2.5",
    stroke: "#AD54B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 9C5.88071 9 7 7.88071 7 6.5C7 5.11929 5.88071 4 4.5 4C3.11929 4 2 5.11929 2 6.5C2 7.88071 3.11929 9 4.5 9Z",
    stroke: "#AD54B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17.5V15.4375C8 13.539 6.433 11.5 4.5 11.5C2.567 11.5 1 13.539 1 15.4375V17.5H2.4L3.1 23H5.9L6.6 17.5H8Z",
    stroke: "#AD54B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1472 5.71881L15.3117 9.50672C15.1841 9.67664 14.989 9.78285 14.7771 9.79786C14.5651 9.81286 14.357 9.73519 14.2068 9.58494L12.7401 8.11828",
    stroke: "#AD54B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdminUserCheck);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDE1LjYxNTRIMTRWMjBMMTguNSAxNS42MTU0SDIxLjVDMjIuMzI4NCAxNS42MTU0IDIzIDE0Ljk2MSAyMyAxNC4xNTM4VjIuNDYxNTRDMjMgMS42NTQzNSAyMi4zMjg0IDEgMjEuNSAxSDEwQzkuMTcxNTcgMSA4LjUgMS42OTI4MSA4LjUgMi41IiBzdHJva2U9IiNBRDU0QjEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUgOUM1Ljg4MDcxIDkgNyA3Ljg4MDcxIDcgNi41QzcgNS4xMTkyOSA1Ljg4MDcxIDQgNC41IDRDMy4xMTkyOSA0IDIgNS4xMTkyOSAyIDYuNUMyIDcuODgwNzEgMy4xMTkyOSA5IDQuNSA5WiIgc3Ryb2tlPSIjQUQ1NEIxIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCAxNy41VjE1LjQzNzVDOCAxMy41MzkgNi40MzMgMTEuNSA0LjUgMTEuNUMyLjU2NyAxMS41IDEgMTMuNTM5IDEgMTUuNDM3NVYxNy41SDIuNEwzLjEgMjNINS45TDYuNiAxNy41SDhaIiBzdHJva2U9IiNBRDU0QjEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4LjE0NzIgNS43MTg4MUwxNS4zMTE3IDkuNTA2NzJDMTUuMTg0MSA5LjY3NjY0IDE0Ljk4OSA5Ljc4Mjg1IDE0Ljc3NzEgOS43OTc4NkMxNC41NjUxIDkuODEyODYgMTQuMzU3IDkuNzM1MTkgMTQuMjA2OCA5LjU4NDk0TDEyLjc0MDEgOC4xMTgyOCIgc3Ryb2tlPSIjQUQ1NEIxIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";